import { render, staticRenderFns } from "./TransplantationDetails.vue?vue&type=template&id=119d3845&"
import script from "./TransplantationDetails.vue?vue&type=script&lang=ts&"
export * from "./TransplantationDetails.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports